<template>
  <div class="comps-carda-item"
    @click="$emit('click')">
    <div class="backimg centerimage gray-bg" ref="backimg"
      :style="'background-image: url(' + imgurl + '); height: ' + height"><!-- 背景图 --></div>
    <h2 v-if="title">{{title}}</h2>
    <h2 v-else>
      <span class="dis-bl ht-20 gray-bg mb-10 wi-120"></span>
    </h2>
    <p class="to-4 silver" v-if="info">{{info}}</p>
    <p class="to-4 silver" v-else>
      <span class="dis-bl ht-18 gray-bg mb-8"></span>
      <span class="dis-bl ht-18 gray-bg mb-8"></span>
      <span class="dis-bl ht-18 gray-bg mb-8"></span>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    imgurl: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    info: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      height: '213px'
    }
  },
  mounted () {
    if (this.$refs.backimg.clientWidth) {
      this.height = (this.$refs.backimg.clientWidth / 100 * 50 + 'px')
    }
  }
}
</script>

<style lang="less" scoped>
  @import url('../../../utils/color.less');
/* 小于等于 750 */
@media screen and (max-width: 751px) and (min-width: 300px) {
  .comps-carda-item {
    width: 100%;
    .backimg {
      width: 100%;
    }
    h2 {
      margin: 20px 0 10px;
      font-family: Georgia, 宋体;
      font-weight: bold;
    }
    p {
      margin: 0;
    }
  }
  .comps-carda-item:hover {
    cursor: pointer;
    h2 {
      color: @primary;
    }
  }
}
/* 大于 750 */
@media screen and (min-width: 751px) {
  .comps-carda-item {
    width: 100%;
    .backimg {
      width: 100%;
    }
    h2 {
      margin: 20px 0 10px;
      font-family: Georgia, 宋体;
      font-weight: bold;
    }
    p {
      margin: 0;
      height: 83px;
    }
  }
  .comps-carda-item:hover {
    cursor: pointer;
    h2 {
      color: @primary;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Models/comps/cardIndustries.vue